<template>
  <div class="list-container">
    <div class="list-bread-crumb-div">
      <ZD-bread-crumb :bConfigList="pageConfig.listBreadCrumb"></ZD-bread-crumb>
    </div>

    <div class="list-content-div">
      <div class="list-header-title-div">家庭充电服务活动列表</div>
      <div class="page-action-btns flex margin-tb-10">
        <div class="flex-grow-1"></div>
        <button class="common-bg-button" @click="showServiceFeeExportDialog">服务费数据导出</button>
        <button class="common-bg-button" @click="showUserVerify">用户验证</button>
        <button class="common-bg-button" @click="handleActivateSwitch">激活切换</button>
        <button class="common-bg-button" @click="handleEditOrder">活动订单编辑</button>
        <button class="common-bg-button" @click="toggleFilters">高级筛选</button>
        <button class="common-bg-button" @click="handleExport">导 出</button>
      </div>

      <div class="multi-query-div el-fade-in-linear" v-if="showMultiQuerys">
        <div class="margin-bottom-16">
          <el-row :gutter="20">
            <el-col :span="6">
              <p class="margin-bottom-5 font-14">关键字搜索</p>
              <el-input clearable v-model="queryInfo.keyWord" size="small" placeholder="请输入活动订单编号/手机号"></el-input>
            </el-col>
            <el-col :span="6">
              <p class="margin-bottom-5 font-14">订单状态</p>
              <el-select v-model="queryInfo.orderStatusName" size="small" clearable placeholder="请选择订单状态"
                style="width: 100%">
                <el-option label="待激活" value="TO_ACTIVATION" />
                <el-option label="使用中" value="IN_USE" />
                <el-option label="换桩中" value="SWAPPING" />
                <el-option label="已解约(买断)" value="IN_CANCELLED_BUYOUT" />
                <el-option label="已解约(退款)" value="IN_CANCELLED_REFUNDED" />
                <el-option label="已解约(到期)" value="IN_EXPIRED" />
              </el-select>
            </el-col>
            <el-col :span="6">
              <p class="margin-bottom-5 font-14">充电桩使用状态</p>
              <el-select v-model="queryInfo.pileStatus" size="small" clearable placeholder="请选择充电桩使用状态"
                style="width: 100%">
                <el-option label="已激活" value="ACTIVATED" />
                <el-option label="已失效" value="INVALID" />
                <el-option label="激活异常" value="ACTIVATE_EXCEPTION" />
              </el-select>
            </el-col>
            <el-col :span="6">
              <p class="margin-bottom-5 font-14">流量服务状态</p>
              <el-select v-model="queryInfo.flowstatus" size="small" clearable placeholder="请选择流量服务状态"
                style="width: 100%">
                <el-option label="正常" value="COMMON" />
                <el-option label="即将到期" value="ABOUT_TO_EXPIRE" />
                <el-option label="已到期" value="EXPIRED" />
                <el-option label="已解约" value="CANCELED" />
              </el-select>
            </el-col>
          </el-row>
        </div>
        <div class="margin-bottom-16">
          <el-row :gutter="20">
            <el-col :span="6">
              <p class="margin-bottom-5 font-14">安装状态</p>
              <el-select v-model="queryInfo.installStatus" size="small" clearable placeholder="请选择安装状态"
                style="width: 100%">
                <el-option label="未勘察未安装" value="INVESTIGATION_INSTALL_INIT" />
                <el-option label="已勘察已安装" value="INVESTIGATION_INSTALL_COMPLETED" />
                <el-option label="已勘察不安装" value="INVESTIGATION_FINISHED_NOT_INSTALL" />
                <el-option label="未勘察不安装" value="INVESTIGATION_INIT_NOT_INSTALL" />
              </el-select>
            </el-col>
            <el-col :span="6">
              <p class="margin-bottom-5 font-14">客服联系状态</p>
              <el-select v-model="queryInfo.activityOrderContractStatusName" size="small" clearable
                placeholder="请选择客服联系状态" style="width: 100%">
                <el-option label="待联系" value="WAIT_CONTRACT" />
                <el-option label="已联系" value="CONTRACTED" />
                <el-option label="未联系上" value="NOT_CONTRACT" />
              </el-select>
            </el-col>
            <el-col :span="6">
              <p class="margin-bottom-5 font-14">充电桩安装完成时间</p>
              <el-date-picker class="full-width" size="small" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss"
                v-model="installCompleteTime" @change="pickInstallCompleteDate(installCompleteTime)" range-separator="-"
                start-placeholder="开始日期" end-placeholder="结束日期" />
            </el-col>
            <el-col :span="6">
              <p class="margin-bottom-5 font-14">充电桩绑定激活时间</p>
              <el-date-picker class="full-width" size="small" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss"
                v-model="bindActivateTime" @change="pickBindActivateDate(bindActivateTime)" range-separator="-"
                start-placeholder="开始日期" end-placeholder="结束日期" />
            </el-col>
          </el-row>
        </div>
        <div class="margin-bottom-16">
          <el-row :gutter="20">
            <el-col :span="6">
              <p class="margin-bottom-5 font-14">订单创建时间</p>
              <el-date-picker class="full-width" size="small" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss"
                v-model="orderCreateTime" @change="pickOrderCreateDate(orderCreateTime)" range-separator="-"
                start-placeholder="开始日期" end-placeholder="结束日期" />
            </el-col>
            <!-- <el-col :span="6">
              <p class="margin-bottom-5 font-14">是否退款</p>
              <el-select v-model="queryInfo.isRefund" size="small" clearable placeholder="请选择是否退款" style="width: 100%">
                <el-option label="是" value="1" />
                <el-option label="否" value="0" />
              </el-select>
            </el-col> -->
            <el-col :span="6">
              <p class="margin-bottom-5 font-14">商家代扣状态</p>
              <el-select v-model="queryInfo.holdAgreement" size="small" clearable placeholder="请选择商家代扣状态"
                style="width: 100%">
                <el-option label="已签约" value="Y" />
                <el-option label="未签约" value="N" />
              </el-select>
            </el-col>
            <el-col :span="6">
              <p class="margin-bottom-5 font-14">解约完成时间</p>
              <el-date-picker class="full-width" size="small" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss"
                v-model="terminateCompleteTime" @change="pickTerminateCompleteDate(terminateCompleteTime)"
                range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期" />
            </el-col>
          </el-row>
        </div>
        <div class="page-action-btns flex margin-tb-10">
          <div class="flex-grow-1"></div>
          <button class="common-bg-button" @click="reset">重 置</button>
          <button class="common-bg-button" @click="getListData(pagination, true)">搜 索</button>
        </div>
      </div>

      <div class="list-table">
        <ZD-table :tableColumns="pageConfig.listColumns" :operates="operates" :tableData="tableData"
          :tableConfig="pageConfig.tableConfig" :selections="selections"
          v-on:updateSelections="(sels) => { selections = sels }">
          <template slot="activityOrderNo" slot-scope="{row}">
            <span style="color: #409EFF; cursor: pointer;" @click="handleActivityOrderNoClick(row)">{{
              row.activityOrderNo }}</span>
          </template>
        </ZD-table>
      </div>

      <div class="list-pagination">
        <ZD-pagination :pagination="pagination" v-on:pageUpdate="getListData"></ZD-pagination>
      </div>

      <!-- 用户验证弹窗 -->
      <el-dialog title="" :visible.sync="verifyDialogVisible" width="15%" @close="handleVerifyClose" center>
        <div class="verify-dialog-body">
          <div class="verify-item center">
            <span class="verify-label">单用户验证开关</span>
          </div>
          <div class="verify-item center">
            <span class="verify-label">同一手机号仅申请一次</span>
          </div>
          <div class="verify-item center">
            <el-radio-group v-model="verifyForm.singleApplyFlag" size="small">
              <el-radio label="ON">开启</el-radio>
              <el-radio label="OFF">关闭</el-radio>
            </el-radio-group>
          </div>
        </div>
        <span slot="footer" class="dialog-footer center">
          <el-button type="primary" @click="handleVerifySubmit">提 交</el-button>
          <el-button @click="handleVerifyClose">取 消</el-button>
        </span>
      </el-dialog>

      <!-- 激活切换弹窗 -->
      <el-dialog title="" :visible.sync="activateDialogVisible" width="15%" @close="handleActivateClose" center>
        <div class="verify-dialog-body">·
          <div class="verify-item center">
            <span class="verify-label">是否下发桩端激活？</span>
          </div>
          <div class="verify-item center">
            <span class="verify-label">桩端激活异常时 可下发尝试激活</span>
          </div>
        </div>
        <span slot="footer" class="dialog-footer center">
          <el-button @click="handleActivateClose">取 消</el-button>
          <el-button type="primary" @click="handleActivateSubmit">下 发</el-button>
        </span>
      </el-dialog>
      <el-dialog title="服务费数据导出" :visible.sync="serviceFeeExportDialogVisible" width="30%" center>
        <div style="padding: 8px 0;">
          <p class="margin-bottom-5 font-14">请选择月份</p>
          <el-date-picker v-model="serviceFeeMonth" class="full-width" size="small" type="month" value-format="yyyy-MM"
            format="yyyy-MM" placeholder="请选择月份" />
        </div>
        <span slot="footer" class="dialog-footer center">
          <el-button @click="serviceFeeExportDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="handleServiceFeeExportConfirm">确 认</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import pageConfig from './page-config'

export default {
  name: 'FamilyChargingServiceActivityList',
  data() {
    return {
      pageConfig,
      tableData: [],
      selections: [],
      pagination: { ...pageConfig.pagination },
      queryInfo: {},
      activityTime: [],
      createTime: [],
      installCompleteTime: [],
      bindActivateTime: [],
      orderCreateTime: [],
      terminateCompleteTime: [],
      showMultiQuerys: false,
      operates: { list: [] },
      verifyDialogVisible: false,
      activateDialogVisible: false,
      serviceFeeExportDialogVisible: false,
      serviceFeeMonth: '',
      verifyForm: {
        mobile: '',
        singleVerifyFlag: 'ON',
        singleApplyFlag: 'ON',
      },
    }
  },
  mounted() {
    window.handleActivityOrderNoClick = (rowStr) => {
      const row = typeof rowStr === 'string' ? JSON.parse(rowStr) : rowStr;
      this.handleActivityOrderNoClick(row);
    };
    this.init()
  },
  beforeDestroy() {
    delete window.handleActivityOrderNoClick;
  },
  methods: {
    init() {
      this.getListData(this.pagination, true)
    },
    getListData(pagination, reload = false) {
      const _ = this
      _.$U.showLoading(_)

      if (reload) {
        _.pagination.current = 1
        _.queryInfo.pageNum = 1
      } else {
        _.pagination.current = pagination.current
        _.queryInfo.pageNum = pagination.current
      }
      _.queryInfo.pageSize = pagination.pageSize
      // 补充企业编号，保持与其他列表请求一致
      _.queryInfo.corpNo = _.$store.state.corpNo

      _.$H.post(_, _.$A.activityOrder.pileActivityOrderPage, _.queryInfo).then((res) => {
        if (res.data && res.data.status === 200) {
          const responseData = res.data.data || {}
          _.tableData = responseData.content || []
          _.pagination.total = responseData.totalElements || 0
        } else {
          _.tableData = []
          _.pagination.total = 0
          _.$U?.error ? _.$U.error(res.data?.messge || '获取数据失败') : _.$message.error(res.data?.messge || '获取数据失败')
        }
        _.$U.hideLoading(_)
      }).catch((err) => {
        _.tableData = []
        _.pagination.total = 0
        _.$U.hideLoading(_)
        _.$U?.error ? _.$U.error('请求失败，请稍后重试') : _.$message.error('请求失败，请稍后重试')
        console.error('获取列表数据失败:', err)
      })
    },
    // 通用日期范围处理方法
    handleDateRange(time, fromField, toField) {
      this.queryInfo[fromField] = time ? time[0] : '';
      this.queryInfo[toField] = time ? time[1] : '';
    },

    pickActivityDate(time) {
      this.handleDateRange(time, 'fromStartTime', 'toEndTime');
    },
    pickCreateDate(time) {
      this.handleDateRange(time, 'fromCreateTime', 'toCreateTime');
    },
    pickInstallCompleteDate(time) {
      this.handleDateRange(time, 'pileInstallCompletedFromTime', 'pileInstallCompletedToTime');
    },
    pickBindActivateDate(time) {
      this.handleDateRange(time, 'bindFromTime', 'bindToTime');
    },
    pickOrderCreateDate(time) {
      this.handleDateRange(time, 'createFromTime', 'createToTime');
    },
    pickTerminateCompleteDate(time) {
      this.handleDateRange(time, 'activityCancelCompletedFromTime', 'activityCancelCompletedToTime');
    },
    toggleFilters() {
      this.showMultiQuerys = !this.showMultiQuerys
    },
    showServiceFeeExportDialog() {
      this.serviceFeeMonth = ''
      this.serviceFeeExportDialogVisible = true
    },
    showUserVerify() {
      const target = this.selections[0] || {}
      this.verifyForm.mobile = target.mobile || target.userMobile || ''
      this.verifyForm.singleVerifyFlag = 'ON'
      this.verifyForm.singleApplyFlag = 'ON'
      this.verifyDialogVisible = true
    },
    handleActivateSwitch() {
      if (!this.checkSelectOne(this.selections)) return
      this.activateDialogVisible = true
    },
    handleEditOrder() {
      if (!this.checkSelectOne(this.selections)) return
      const target = this.selections[0] || {}
      this.$router.push({
        name: 'familyChargingProductOrderDetail',
        query: { orderNo: target.activityOrderNo },
      })
    },
    handleActivityOrderNoClick(row) {
      // 点击活动订单编号打开详情页面
      this.$router.push({
        name: 'familyChargingProductOrderDetail',
        query: { orderNo: row.activityOrderNo },
      })
    },
    handleExport() {
      let _ = this;
      let urls = "";
      const host = window.location.hostname;
      if (host.includes("shzhida.com")) {
        urls = "http://ocharge.shzhida.com:6771";
      } else {
        urls = "http://192.168.8.174:7997";
      }
      _.$U.showLoading(_);
      _.$H.post(_, _.$A.activityOrder.pileActivityOrderExcel, _.queryInfo).then((res) => {
        if (res.data && res.data.data) {
          if (res.data.data.base64 || res.data.data.fileName) {
            _.$U.saveExcelFile(res.data.data);
          }
          if (res.data.data.filePath) {
            var downUrl = res.data.data.filePath;
            if (!downUrl.startsWith('http')) {
              downUrl = urls + downUrl;
            }
            window.open(downUrl, "_blank");
          }
          _.$U.success('导出成功');
        } else {
          _.$U.error(res.data?.msg || res.data?.message || '导出失败：未获取到文件信息');
        }
        _.$U.hideLoading(_);
      }).catch(err => {
        _.$U.hideLoading(_);
        console.error('导出失败:', err);
        _.$U.error(err?.response?.data?.msg || err?.response?.data?.message || err?.message || '导出失败');
      });
    },
    handleServiceFeeExportConfirm() {
      const _ = this
      if (!_.serviceFeeMonth) {
        _.$U?.error ? _.$U.error('请先选择月份') : _.$message.error('请先选择月份')
        return
      }

      let urls = ''
      const host = window.location.hostname
      if (host.includes('shzhida.com')) {
        urls = 'http://ocharge.shzhida.com:6771'
      } else {
        urls = 'http://192.168.8.174:7997'
      }

      const params = new FormData()
      params.append('month', _.serviceFeeMonth)
      params.append('activityType', '1')

      _.$U.showLoading(_)
      _.$H.post(_, '/api/d1/axbApp/exportServiceFeeData', params).then((res) => {
        if (res.data && res.data.data) {
          const data = res.data.data
          if (data.base64 || data.fileName) {
            _.$U.saveExcelFile(data)
          }
          if (data.filePath) {
            let downUrl = data.filePath
            if (!downUrl.startsWith('http')) {
              downUrl = urls + downUrl
            }
            window.open(downUrl, '_blank')
          }
          _.$U?.success ? _.$U.success('导出成功') : _.$message.success('导出成功')
          _.serviceFeeExportDialogVisible = false
        } else {
          _.$U?.error ? _.$U.error(res.data?.msg || res.data?.message || '导出失败：未获取到文件信息') : _.$message.error(res.data?.msg || res.data?.message || '导出失败：未获取到文件信息')
        }
      }).catch((err) => {
        _.$U?.error ? _.$U.error(err?.response?.data?.msg || err?.response?.data?.message || err?.message || '导出失败') : _.$message.error(err?.response?.data?.msg || err?.response?.data?.message || err?.message || '导出失败')
      }).finally(() => {
        _.$U.hideLoading(_)
      })
    },
    checkSelectOne(selections) {
      if (!selections || selections.length < 1) {
        this.$U?.error ? this.$U.error('请选择需要操作的对象') : this.$message.error('请选择需要操作的对象')
        return false
      }
      if (selections.length > 1) {
        this.$U?.error ? this.$U.error('只能选择一个操作的对象') : this.$message.error('只能选择一个操作的对象')
        return false
      }
      return true
    },
    handleVerifySubmit() {
      const _ = this
      _.$U.showLoading(_)
      const params = {
        keyWord: _.verifyForm.singleApplyFlag === 'ON' ? 'Y' : 'N'
      }
      _.$H.post(_, _.$A.activityOrder.setCheckOnce, params).then((res) => {
        if (res.data && res.data.status === 200) {
          _.$U?.success ? _.$U.success('设置成功') : _.$message.success('设置成功')
          _.verifyDialogVisible = false
        } else {
          _.$U?.error ? _.$U.error(res.data?.message || '设置失败') : _.$message.error(res.data?.message || '设置失败')
        }
        _.$U.hideLoading(_)
      }).catch((err) => {
        _.$U.hideLoading(_)
        _.$U?.error ? _.$U.error('请求失败，请稍后重试') : _.$message.error('请求失败，请稍后重试')
        console.error('用户验证设置失败:', err)
      })
    },
    handleVerifyClose() {
      this.verifyDialogVisible = false
    },
    handleActivateSubmit() {
      const _ = this
      const target = _.selections[0] || {}
      if (!target.pileCode) {
        _.$U?.error ? _.$U.error('所选记录无充电桩编号') : _.$message.error('所选记录无充电桩编号')
        return
      }
      _.$U.showLoading(_)
      const params = {
        pileCode: target.pileCode
      }
      _.$H.post(_, _.$A.activityOrder.pileActivateExchange, params).then((res) => {
        if (res.data && res.data.status === 200) {
          _.$U?.success ? _.$U.success('下发成功') : _.$message.success('下发成功')
          _.activateDialogVisible = false
          _.getListData(_.pagination, false)
        } else {
          _.$U?.error ? _.$U.error(res.data?.message || '下发失败') : _.$message.error(res.data?.message || '下发失败')
        }
        _.$U.hideLoading(_)
      }).catch((err) => {
        _.$U.hideLoading(_)
        _.$U?.error ? _.$U.error('请求失败，请稍后重试') : _.$message.error('请求失败，请稍后重试')
        console.error('激活切换失败:', err)
      })
    },
    handleActivateClose() {
      this.activateDialogVisible = false
    },
    reset() {
      this.queryInfo = {}
      const timeFields = ['activityTime', 'createTime', 'installCompleteTime', 'bindActivateTime', 'orderCreateTime', 'terminateCompleteTime']
      timeFields.forEach(field => {
        this[field] = []
      })
      this.getListData(this.pagination, true)
    },
  },
}
</script>

<style lang="less" scoped>
.list-header-title-div {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.margin-tb-10 {
  margin: 10px 0;
}

.multi-query-div {
  padding: 16px;
  background: #f6f8fb;
  border-radius: 6px;
}

.verify-item {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  font-size: 20px;
}

.verify-label {
  display: inline-block;
  width: 100%;
  color: #333;
  font-size: 20px;
}

.verify-dialog-body {
  text-align: center;
  font-size: 20px;
}

.verify-item.center {
  justify-content: center;
}

.dialog-footer.center {
  text-align: center;
  width: 100%;
  display: flex;
  justify-content: center;
  gap: 12px;
}

.verify-item .el-radio {
  font-size: 20px;
}
</style>
